export enum DealerType {
  dealerUser = 1,
  wholesalerUser = 2,
  dealerGroupUser = 3,
  clientSupportUser = 4,
  universalUser = 5,
  dealerLoaderUser = 1000
}

export default DealerType;
